import React, { useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { UploadChangeParam } from 'antd/lib/upload';
import Configs from 'config';
import { CUploadFileProps } from 'constants/base.const';
import { Form, Button, Upload, message, Input } from 'antd';
import styled from 'styled-components';

const { Dragger } = Upload;

const AttachmentModal = ({ visible, disabled, form }: any) => {
  const [uploadVisible, setUploadVisible] = useState(true);

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={
        <Button type='primary' onClick={() => disabled(false)}>
          등록
        </Button>
      }
      onCancel={() => disabled(false)}
    >
      <Title>첨부파일 등록</Title>

      <Form.Item
        name='resume_files'
        className='form-item'
        shouldUpdate={(prevValues, currentValues) => prevValues.resume_files !== currentValues.resume_files}
        valuePropName='fileList'
        getValueFromEvent={(e: UploadChangeParam) => (Array.isArray(e) ? e : e && e?.fileList)}
      >
        <Dragger
          style={{ backgroundColor: '#ffffff' }}
          name='file'
          {...CUploadFileProps}
          // disabled={form.getFieldValue('resume_files') ? true : false}
          multiple={false}
          onDrop={() => form.setFieldsValue({ resume_files: null })}
          action={`${Configs.API_HOST}/community/file`}
          onChange={(info: UploadChangeParam) => {
            const { status } = info.file;
            form.setFieldsValue({ resume_file_id: info.file.response?.id });

            if (status === 'done') {
              message.success(`${info.file.name} 업로드에 성공했습니다.`);
              setUploadVisible(false);
            } else if (status === 'error') {
              message.error(`${info.file.name} 업로드에 실패했습니다.`);
            } else if (status === 'removed') {
              if (info.fileList.length === 0) {
                setUploadVisible(true);
              }
            }
          }}
        >
          {form.getFieldValue('resume_files')
            ? form.getFieldValue('resume_files')[0]?.name
            : '파일을 드래그하거나 여기를 클릭해주세요'}
        </Dragger>
        {/* <Form.Item name='resume_file_id' hidden>
          <Input />
        </Form.Item> */}
      </Form.Item>
    </Modal>
  );
};

export default AttachmentModal;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 900;
`;
